<div class="animated fadeIn">
    <div class="card">
  
      <div class="card-body" [style]="{'border': '1px solid red!important;'}">
  
        <div class="row">
          <div class="col-sm-3 col-md-3">
  
            <p-table #dtModel [columns]="cols" [loading]="loading" selectionMode="single" [(selection)]="selectedModelcores" 
              [value]="modelcores"
              [globalFilterFields]="['designation','objet' ]"
              [scrollable]="true">
  
  
              <ng-template pTemplate="caption">
                <div style="text-align: right">
  
                  <span *ngIf='modelcores'>
  
                    {{modelcores.length}} Model </span>
                  <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                  <input type="text" pInputText placeholder="Global Filter" (input)="dtModel.filterGlobal($event.target.value, 'contains')" style="width:auto">
                </div>
              </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr>
  
                  <th [style]="{'width':'300px'}">
                    <button type="button" (click)="createModelcores()" class="btn btn-sm btn-warning">
                      <i class="icon-plus"></i> New </button>
  
                  </th>
                  <th [style]="{'width':'5px!important'}" data-ng-style="5" *ngFor="let col of cols" [pSortableColumn]="col.field">
                    <p-sortIcon [style]="{'width':'5px!important'}" [field]="col.field"></p-sortIcon>
  
                  </th>
                  <th [style]="{'width':'50px'}">
                    <button type="button" (click)="removeModelcores()" [disabled]='!selectedModelcores' class="btn btn-sm btn-danger">
                      <i class="fa fa-remove"></i>Remove
                    </button>
                  </th>
                </tr>
  
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [pSelectableRow]="rowData" [ngStyle]="{'background-color': (selectedModelcores) &&  (rowData.modelcoresId === selectedModelcores.modelcoresId) ? '#ef8b00' :'white'  }">
  
  
                  <td>
                    {{rowData.designation}}
                    <span class="badge " [style.background-color]="'red'"> </span>
                  </td>
  
  
  
                </tr>
              </ng-template>
  
  
  
            </p-table>
  
  
          </div>
          <div class="col-sm-9 col-md-9">
            <div *ngIf='selectedModelcores'>
  
  
              <div class="row">
                <div class="col-10">
                  <div [style.font-size]=" '23px' " [style.color]=" 'red' " *ngIf='!isEdit'>
                    <strong>{{selectedModelcores.designation | uppercase}}</strong>
                  </div>
                  <input *ngIf="isEdit" class="col-md-9" type="text" class="form-control" [(ngModel)]="selectedModelcores.designation" placeholder="Enter modelcores designation">
                </div>
                <div class="col-2">
                  <button *ngIf='!isEdit' type="button" (click)="isEdit=true;  " class="btn btn-sm btn-outline-primary">
                    <i class="fa fa-edit"></i> Edit </button>
                  <button *ngIf='isEdit' type="button" (click)="isEdit=false;save()" class="btn btn-sm btn-outline-primary">
                    <i class="fa fa-save"></i> Save </button>
                  <button *ngIf='isEdit' type="button" (click)="isEdit=false;" class="btn btn-sm btn-outline-danger">
                    <i class="fa fa-remove"></i> Cancel</button>
                </div>
              </div>
              <br />
              <div class="row">
  
  
                <div class="col-6">
  
  
  
                  <label class="col-md-3 ">
                    <strong> Objet:</strong>
                  </label>
                  <input *ngIf="isEdit" class="col-md-9" type="text" class="form-control" [(ngModel)]="selectedModelcores.objet">
                  <span *ngIf="!isEdit" class="col-md-9">{{selectedModelcores.objet }}</span>
  
                  <br />
  
  
  
                </div>
  
  
                <div class="col-6">
  
  
  
  
                  <label class="col-md-3 ">
                    <strong> Projets:</strong>
                  </label>
  
                  <p-multiSelect id="projet" *ngIf="isEdit" class="col-md-9" class="form-control" (onChange)="selectProjectPr()" [options]="projets"
                    [(ngModel)]="selectedProject"></p-multiSelect>
                  <span *ngIf="!isEdit" class="col-md-9">{{selectedModelcores.projets }}</span>
  
  
                  <br />
                </div>
                
              </div>
  
  
  
  
  
  
  
  
              <ckeditor [(ngModel)]="selectedModelcores.corp" [config]="CkeditorConfig" *ngIf="isEdit" debounce="500">
  
  
              </ckeditor>
  
              <ckeditor [(ngModel)]="selectedModelcores.corp" [config]="CkeditorConfig1" [readonly]="true" *ngIf="!isEdit" debounce="500">
  
  
              </ckeditor>
              <br />
  
  
  
  
  
  
  
  
  
            </div>
          </div>
  
        </div>
      </div>
  
  
    </div>
  
  </div>